<template>
	<div class="customer-benefits">
		<div class="customer-benefits--items">
			<b-row>
				<b-col md="4">
					<div class="customer-benefits--items-column">
						<Item
							title="Nur 1x"
							:text="oneTimeText"
							color="purple"
						/>
					</div>
				</b-col>
				<b-col md="4">
					<div class="customer-benefits--items-column">
						<Item
							title="Erhalte nur noch passende Vorschläge und entscheide!"
							text="Du musst nicht dauernd suchen, sondern stelle die Job-Filter ein, wie du möchtest! skilldoo informiert dich genau dann, wenn es einen Best-Match gibt."
							color="turquoise"
						/>
					</div>
				</b-col>
				<b-col md="4">
					<div class="customer-benefits--items-column">
						<Item
							title="Niemand erfährt, dass Du es bist!"
							text="Denn deine Jobvisitenkarte ist anonym.<br/>Erst wenn dir ein Arbeitgeber seine Daten offenlegt, entscheidest Du, ob du deinen Namen und persönlichen Daten hergibst."
							color="gold"
						/>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";
import Item from "./customer-benefits/Item.vue";

const HOW_IT_WORKS_ITEMS = [
	{
		text: 'Jobprofil veröffentlichen',
		items: [
			'schnell mit wenigen Klicks',
			'einfach'
		],
		free: true,
	},
	{
		text: 'Best-Match-System zeigt passende Bewerber',
		items: [
			'einfach Notizen erstellen',
			'passende Personen vormerken'
		],
		free: true,
	},
	{
		text: 'Kontaktanfragen',
		items: [
			'annehmen',
			'senden'
		],
		free: false,
	},
	{
		text: 'Weitere Jobprofile anlegen und veröffentlichen',
		items: [
			'unbeschränkte Anzahl',
			'noch weniger Zeitaufwand'
		],
		free: true,
	},
	{
		text: 'Termine',
		items: [
			'vereinbaren',
			'zusagen',
			'absagen'
		],
		free: true,
	},
];

export default {
	components: {Item, Icon},

	props: {
		onWhite: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	computed: {
		oneTimeText ()
		{
			return `Du legst 1x deine anonyme Jobvisitenkarte an<br/>
			und wirst ab sofort von passenden Jobs gefunden.<br/>
			<ul>
			<li>Du musst nicht mehr 1.000 Jobinserate lesen, die oft nicht passen.</li>
			<li>Du musst dich nicht mehr auf verschiedenen Webseiten einzeln bewerben!</li>
			</ul>
			Du machst ab sofort 1 Klick bei Jobs, die für dich passen und dich interessieren.`;
		}
	}
}
</script>
